import { useTranslation } from "react-i18next";
import ExpendOtherTableBody from "./ExpendOtherTableBody";
import { Table } from "react-bootstrap";

const OexpendOtherBody = ({expends, setShowExpendInfo, setShowSpinnerExpend, onlyView = false}) => {
    const { t } = useTranslation(['Objects']);

    return (<>
    <div className="crm-table-wrap">
        <Table className="ExpandTeamTable table-hover table">
            <thead>
                <tr className="bg-light">
                    <td className="head-user">{t('fieldsService.user')}</td>
                    <td className="head-team">{t('fieldsService.expendType')}</td>
                    {!onlyView && 
                    (<td className="head-date">{t('fieldsService.date')}</td>)}
                    <td className="head-amount">{t('fieldsService.amount')}</td>
                    <td className="head-actions">{t('fieldsService.actions')}</td>
                </tr>
            </thead>  

            <ExpendOtherTableBody  
                onlyView={onlyView}
                expends={expends} 
                setShowExpendInfo={setShowExpendInfo} 
                setShowSpinnerExpend={setShowSpinnerExpend}/>
            
        </Table>
    </div>
    </>)
}
export default OexpendOtherBody;